









































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import { STORE_KEY, store } from "./_store";
import WarehouseRemainForm from "./WarehouseRemainForm/WarehouseRemainForm.vue";
import WarehouseResortForm from "./WarehouseResortForm/WarehouseResortForm.vue";

import TitleBar from "@/components/Elements/TitleBar.vue";
import moment from "moment";
import XLSX from "xlsx";

@Component({
  computed: {
    ...mapState("ubic", ["token", "actor"]),
    ...mapGetters(STORE_KEY, ["total"]),
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",
      "meta",
      "days",

      "filter",

      "documents",
      "lastMeta",
      "uploadRemainsCount",
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, ["toggleSticker"]),
  },
  components: {
    TitleBar,
  },
})
export default class WarehousesList extends Vue {
  public warehouse_id: any = null;
  public targetDate: any = null;
  public actor!: any;
  public visibleQuantity: boolean = false;
  public oldFormat: boolean = false;
  openedDetails: any[] = [];
  documents!: any[];
  uploadRemainsCount!: number;
  loaded!: boolean;

  get titleStack() {
    return ["Склады"];
  }

  get defaultSort() {
    return [
      this.$route.query.sortField || "quantity",
      this.$route.query.sortDirection || "asc",
    ];
  }

  get today() {
    return moment().format("DD.MM.YYYY");
  }

  get selectedView() {
    return this.$route.query.view || "day";
  }

  setParams(filterName: string, filterValue: any) {
    console.log(filterName, filterValue);
    this.$router.replace({
      query: {
        ...this.$route.query,
        [filterName]: filterValue,
      },
    });
  }

  unselectableDates(day: any) {
    return moment().date() > moment(day).date();
  }
  expandAllWarehouses() {
    this.documents.map((row: any) => {
      // @ts-ignore
      this.$refs.table.openDetailRow(row);
    });
  }
  collapseAllWarehouses() {
    this.documents.map((row: any) => {
      // @ts-ignore
      this.$refs.table.closeDetailRow(row);
    });
  }

  confirmDeleteTransportCosts(row: any) {
    this.$buefy.dialog.confirm({
      message: `Удалить запись на сумму ${row.costs} руб. (клиент: ${row.client_name}, зона: ${row.delivery_zone_name})`,
      confirmText: "Удалить",
      cancelText: "Отмена",
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store
          .dispatch(`${STORE_KEY}/deleteTransportCost`, {
            id: row.id,
          })
          .then((result) => {
            this.$buefy.snackbar.open(`Запись удалена`);
            this.handleParamsChange();
          })
          .catch(() => {
            this.$buefy.snackbar.open({
              type: "is-warning",
              message: `При сохранении возникли проблемы. Попробуйте позже.`,
            });
          });
      },
    });
  }

  onSort(field: any, direction: any) {
    this.$store.dispatch(`${STORE_KEY}/setSort`, {
      field,
      direction,
    });
  }

  private delayFilter: any = null;

  onTargetDateChange(targetDate: string) {
    console.log("onTargetDateChange", targetDate);
    this.$router.replace({
      query: {
        ...this.$route.query,
        targetDate: moment(targetDate).format("YYYY-MM-DD"),
      },
    });
  }

  onOldFormat($event: any) {
    console.log("onOldFormat", $event);
    this.$router.replace({
      query: { ...this.$route.query, old_format: $event },
    });
  }

  onWarehouseChange(warehouse_id: string) {
    console.log("onWarehouseChange", warehouse_id);
    this.$router.replace({
      query: { ...this.$route.query, warehouse_id },
    });
  }

  tableToExcel() {
    const csvContent: any[] = [];

    csvContent.push(...this.$store.getters[`${STORE_KEY}/exportData`]);
    const ws = XLSX.utils.aoa_to_sheet(csvContent);
    // @ts-ignore
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellref = XLSX.utils.encode_cell({ c: C, r: R }); // construct A1 reference for cell
        if (!ws[cellref] || C < 3 || R < 1) continue; // if cell doesn't exist, move on
        const cell = ws[cellref];
        cell.t = "n";
        cell.z = "0.00";
      }
    }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Отчет");
    XLSX.writeFile(wb, "export.xlsx");
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch("$route.query")
  public handleParamsChange() {
    if (this.$route.query.targetDate) {
      // @ts-ignore
      this.targetDate = moment(this.$route.query.targetDate).toDate();
    } else {
      this.targetDate = moment()
        .add(1, "day")
        .toDate();
    }
    if (this.$route.query.warehouse_id) {
      this.warehouse_id = this.$route.query.warehouse_id;
      this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
    }
    // @ts-ignore
    this.oldFormat = this.$route.query.old_format == "true";
  }
}
